module.exports = __webpack_public_path__ + "8523a608a1b74b5d34a42096283ff193.svg";